import React,{useEffect,useState} from 'react';
import {analytics} from './service';
import {analyticsNotice} from './notice';
import Button from '../components/ui/Button';
import CustomerProfileSection from '../components/profile/CustomerProfileSection';
export const OPEN_ANALYTICS_PREFERENCES='stirup:open-analytics-preferences';
export default function AnalyticsPreferences(){
  const [state,setState]=useState(analytics.getState);
  useEffect(()=>analytics.subscribe(()=>setState(analytics.getState())),[]);
  return <CustomerProfileSection title="Statistiche facoltative"><div className="prf-body">
    <p>Scelta su questo browser o installazione: {state.choice==='granted'?'consenso accordato':state.choice==='denied'?'consenso rifiutato':'nessuna scelta valida'}.</p>
    <p>Puoi accettare o revocare il consenso senza accedere a un account. La scelta è separata dalle preferenze marketing.</p>
    <Button onClick={()=>window.dispatchEvent(new Event(OPEN_ANALYTICS_PREFERENCES))}>Modifica preferenze statistiche</Button>
    <details><summary>Informativa statistiche — {analyticsNotice.version}</summary><p style={{whiteSpace:'pre-line'}}>{analyticsNotice.text}</p></details>
    <p><a href="https://www.stirup.it/privacy.html" target="_blank" rel="noopener noreferrer">Informativa Privacy</a></p>
  </div></CustomerProfileSection>;
}
